import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import classes from "./TextAreaInput.scss";
import classNames from "classnames";
import Textarea from "react-textarea-autosize";
import UIBaseComponent from "UIComponents/UIBaseComponent";

class TextAreaInput extends UIBaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      keysDown: {},
    };
  }

  handleKeyDown = event => {
    const kd = this.state.keysDown;
    kd[event.keyCode] = true;
    this.setState({ keysDown: kd });

    if (kd[16] && kd[13] && this.props.allowShiftEnter) {
      event.preventDefault();
      const updateVal = `${event.target.value}\r`;
      kd[event.keyCode] = false;
      this.setState({ keysDown: kd });
      this.updateValue(updateVal);
    } else if (event.key == "Enter" && this.props.onEnterPress) {
      event.preventDefault();
      this.props.onEnterPress(event.target.value);
      this.setState({ keysDown: {} });
    }
    if (this.props.onKeyDown) {
      this.props.onKeyDown(event);
    }
  };

  handleKeyUp = e => {
    if (this.props.onEnterPress) {
      const kd = this.state.keysDown;
      kd[e.keyCode] = false;
      this.setState({ keysDown: kd });
    }
    if (this.props.onKeyUp) {
      this.props.onKeyUp(e);
    }
  };

  handleFocus = e => {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    } else {
      this.onFocus({ value: e?.taget?.value });
    }
  };

  handleBlur = e => {
    if (this.props.onBlur) {
      this.props.onBlur(e);
    } else {
      this.onBlur({ value: e.target.value });
    }
  };

  // renderView = () => {
  //   return (
  //     <div
  //       className={classes.viewInputText}
  //       style={{ ...this.props.textAreaStyles }}
  //     >
  //       {this.props.value}
  //     </div>
  //   );
  // };

  // renderViewEmpty = () => {
  //   const { emptyText, textAreaStyles } = this.props;
  //   return (
  //     <div className={classes.inputText} style={{ ...textAreaStyles }}>
  //       {emptyText}
  //     </div>
  //   );
  // };

  renderEdit = () => {
    const {
      disabled,
      maxRows,
      minRows,
      textAreaStyles,
      name,
      placeholder,
      autoFocus,
      showMaxCharacterLength,
      maxLength,
      className,
      errorStyle,
      value,
      onPaste,
      testId,
      onMouseDown,
    } = this.props;
    const { error } = this.state;
    const inputText = classNames(
      { [classes.inputText]: true },
      { [classes.inputTextDisable]: disabled },
      { [classes.error]: !!error },
      { [className]: true }
    );

    let updatedInputStyle = { ...textAreaStyles };

    if (disabled) {
      updatedInputStyle = { ...updatedInputStyle, cursor: "not-allowed" };
    }
    if (error) {
      updatedInputStyle = { ...updatedInputStyle, ...errorStyle };
    }

    return (
      <div className={classes.container}>
        <Textarea
          disabled={disabled}
          maxRows={maxRows}
          minRows={minRows}
          className={inputText}
          type="text"
          value={value ? value : ""}
          onChange={e => this.updateValue(e.target.value)}
          onKeyDown={e => this.handleKeyDown(e)}
          onKeyUp={e => this.handleKeyUp(e)}
          onBlur={e => this.handleBlur(e)}
          onFocus={e => this.handleFocus(e)}
          onMouseDown={onMouseDown}
          style={updatedInputStyle}
          name={name}
          inputRef={this.updateInputRef}
          placeholder={placeholder}
          autoFocus={autoFocus}
          onPaste={onPaste}
          data-test-id={testId ? testId : undefined}
        />
        {showMaxCharacterLength ? (
          <div className={classes.inputLength}>
            {maxLength - _.get(value, "length", 0)}
          </div>
        ) : null}
      </div>
    );
  };
}

TextAreaInput.defaultProps = {
  ...UIBaseComponent.defaultProps,
  textAreaStyles: {},
  minRows: 3,
  allowShiftEnter: false,
  showMaxCharacterLength: false,
  autoFocus: false,
  onMouseDown: _.noop,
};

TextAreaInput.propTypes = {
  ...UIBaseComponent.propTypes,
  showMaxLength: PropTypes.bool,
  maxRows: PropTypes.number,
  minRows: PropTypes.number,
  maxLength: PropTypes.number,
  textAreaStyles: PropTypes.object,
  onEnterPress: PropTypes.func,
  allowShiftEnter: PropTypes.bool,
  inputRef: PropTypes.func,
  autoFocus: PropTypes.bool,
  onKeyUp: PropTypes.func,
  onKeyDown: PropTypes.func,
  onPaste: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseDown: PropTypes.func,
};

export default TextAreaInput;
